export var DeliveryOptions;
(function (DeliveryOptions) {
    DeliveryOptions["ALL_CHANNELS"] = "All channels";
    DeliveryOptions["CUSTOM"] = "Custom";
})(DeliveryOptions || (DeliveryOptions = {}));
